// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reset-button {
  color: #3387df;
  font-size: 16px;
  font-weight: bold;
  border: 1px solid #3387df;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 30px;
  padding-right: 30px;
  border-radius: 50px;
  margin-right: 10px;
}

.cancel-button {
  color: #3387df;
  font-size: 16px;
  font-weight: bold;
  border: 1px solid #005cbc;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 8px;
  padding-bottom: 8px;
  border-radius: 50px;
  margin-right: 10px;
}

.save-button {
  color: white;
  font-size: 16px;
  font-weight: bold;
  background-color: #005cbc;
  border: 1px solid #005cbc;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 8px;
  padding-bottom: 8px;
  border-radius: 50px;
  margin-right: 10px;
}

.table-holder::-webkit-scrollbar {
  /* height: 10px;  */
  background-color: grey;
  width: 10px;
  border-radius: 10px;
}

.table-holder::-webkit-scrollbar-corner {
  background-color: #1d1d1d;
}

.table-holder::-webkit-scrollbar-thumb {
  background-color: rgb(55, 55, 55); /* Color of the scrollbar thumb */
  border-radius: 10px;
  border: 2px solid grey;
}

.table-holder {
  overflow: auto;
  height: 42.5vh;
}

table {
  width: 100%;
  table-layout: fixed;
}

th,
td {
  text-align: left;
  padding: 8px;
  width: 190px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Datashow/dataShow.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC,EAAE,iCAAiC;EACpE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,YAAY;EACZ,YAAY;AACd","sourcesContent":[".reset-button {\n  color: #3387df;\n  font-size: 16px;\n  font-weight: bold;\n  border: 1px solid #3387df;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding-left: 30px;\n  padding-right: 30px;\n  border-radius: 50px;\n  margin-right: 10px;\n}\n\n.cancel-button {\n  color: #3387df;\n  font-size: 16px;\n  font-weight: bold;\n  border: 1px solid #005cbc;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding-left: 20px;\n  padding-right: 20px;\n  padding-top: 8px;\n  padding-bottom: 8px;\n  border-radius: 50px;\n  margin-right: 10px;\n}\n\n.save-button {\n  color: white;\n  font-size: 16px;\n  font-weight: bold;\n  background-color: #005cbc;\n  border: 1px solid #005cbc;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding-left: 20px;\n  padding-right: 20px;\n  padding-top: 8px;\n  padding-bottom: 8px;\n  border-radius: 50px;\n  margin-right: 10px;\n}\n\n.table-holder::-webkit-scrollbar {\n  /* height: 10px;  */\n  background-color: grey;\n  width: 10px;\n  border-radius: 10px;\n}\n\n.table-holder::-webkit-scrollbar-corner {\n  background-color: #1d1d1d;\n}\n\n.table-holder::-webkit-scrollbar-thumb {\n  background-color: rgb(55, 55, 55); /* Color of the scrollbar thumb */\n  border-radius: 10px;\n  border: 2px solid grey;\n}\n\n.table-holder {\n  overflow: auto;\n  height: 42.5vh;\n}\n\ntable {\n  width: 100%;\n  table-layout: fixed;\n}\n\nth,\ntd {\n  text-align: left;\n  padding: 8px;\n  width: 190px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
